export default "__VITE_ASSET__D$Ijf6hO__"